import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Button } from 'primereact/button'
import { Column } from 'primereact/column'

import { RootState } from '../../redux/store'
import localizeDate from '../../../common/utils/localizeDate'
import {
    useReportGetReportsForAdminQuery,
    useCompanyGetReportDeliverySchedulesQuery,
    ReportDeliverySchedule,
} from '../../../common/redux/api/web-api'
import { WidgetLayout } from '../../../lib/widget-layout'
import useText from '../../../common/hooks/useText'
import { Table } from '../../../common/uikit/Table'

export const DummyAutomaticReportDeliveriesTable = () => {
    const text = useText()

    const { selectedCompanyId } = useSelector((state: RootState) => state.user)

    const { data: reports, isLoading } = useReportGetReportsForAdminQuery({
        selectedCompanyId,
    })
    const reportNames = useMemo(() => new Map(reports?.map((i) => [i.id, i.name])), [reports])

    const { data: reportDeliverySchedules } = useCompanyGetReportDeliverySchedulesQuery({
        companyId: selectedCompanyId,
    })

    return (
        <>
            <WidgetLayout
                title={`${text('lblAutomaticReportDeliveriesField')}`}
                headerButtons={<Button type="button" icon="pi pi-plus" label={text('lblAdd')} disabled />}
            >
                <Table
                    value={reportDeliverySchedules ?? []}
                    loading={isLoading}
                    dataKey="id"
                    pt={{ table: { 'aria-label': text('lblAutomaticReportDeliveriesField') } }}
                    rowClassName={() => 'pointer'}
                    data-testid="blocked-automatic-report-deliveries-table"
                >
                    <Column
                        field="active"
                        header={text('lblActive')}
                        bodyClassName="w-1rem"
                        body={() => (
                            <div className="flex justify-content-center">
                                <i
                                    className="pi pi-ban"
                                    aria-label={text('lblBlockedByTier')}
                                    title={text('lblBlockedByTier')}
                                />
                            </div>
                        )}
                    />
                    <Column
                        field="reportId"
                        header={text('lblReport')}
                        body={(reportDeliverySchedule: ReportDeliverySchedule) =>
                            reportDeliverySchedule.reportId && reportNames.get(reportDeliverySchedule.reportId)
                        }
                    />
                    <Column field="deliveryType" header={text('lblType')} />
                    <Column field="deliveryInterval" header={text('lblInterval')} />
                    <Column field="receiverEmail" header={text('lblReceiverEmail')} />
                    <Column
                        field="lastSent"
                        header={text('lblLastSent')}
                        body={(reportDeliverySchedule: ReportDeliverySchedule) =>
                            localizeDate(reportDeliverySchedule.lastSent)
                        }
                    />
                    <Column body={() => null} />
                </Table>
            </WidgetLayout>
        </>
    )
}
